/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetAdvertisersRequest} from '@cash-web/protos/squareup/cash/cashplato/api/v1/cash_plato_service.pb'
import {GetAdvertisersResponse} from '@cash-web/protos/squareup/cash/cashplato/api/v1/cash_plato_service.pb'


export const getAdvertisers = (request:GetAdvertisersRequest, options?: CashRequestOptions) => post<GetAdvertisersRequest, GetAdvertisersResponse>("/2.0/cash/get-advertisers", request, {...options, rejectOnError: true })